import accordion from './accordion';
import actionsPopoverContainer from './actionsPopoverContainer';
import avatar from './avatar';
import badge from './badge';
import banner from './banner';
import bannerIconBackground from './bannerIconBackground';
import breadCrumbs from './breadCrumbs';
import button from './button';
import buttonGroup from './buttonGroup';
import buttonSegment from './buttonSegment';
import checkBox from './checkBox';
import chip from './chip';
import drawer from './drawer';
import drawerHeader from './drawerHeader';
import drawerWide from './drawerWide';
import dropzone from './dropzone';
import emptyState from './emptyState';
import emptyStateTopImageTableVariant from './emptyStateTopImageTableVariant';
import exceptionList from './exceptionList';
import fieldBox from './fieldBox';
import horizontalWizardActive from './horizontalWizardNavigation/horizontalWizardActive';
import horizontalWizardClosed from './horizontalWizardNavigation/horizontalWizardClosed';
import horizontalWizardIcon from './horizontalWizardNavigation/horizontalWizardIcon';
import horizontalWizardWarnings from './horizontalWizardNavigation/horizontalWizardWarnings';
import textarea from './textAreaBox';
import menu from './menu';
import menuMainLinks from './menuMainLinks';
import menuSubLinks from './menuSubLinks';
import modalContent from './modalContent';
import modal from './modal';
import multiAvatar from './multiAvatar';
import navigation from './navigation';
import optionList from './optionList';
import optionListElement from './optionListElement';
import radioButton from './radioButton';
import tableBody from './table/body';
import tableRow from './table/row';
import tag from './tag';
import timepicker from './timepicker';
import toastContainer from './toastContainer';
import toastTextContainer from './toastTextContainer';
import toastTextWidth from './toastTextWidth';
import toggle from './toggle';
import toggleCircle from './toggleCircle';
import { headerHoverInput, headerHoverSearchButton } from './table/tableHoverHeader';
import { tabActiveSizes as tabActive, tabBadgeSizes as tabBadge, tabCloseButtonSizes as tabCloseButton, tabSecondarySizes as tabSecondary, tabSizes as tab, } from './tab';
import dropdownMenu from './dropdown/dropdownMenu';
import dropdownOption from './dropdown/dropdownOption';
import wideCheckBox from './wideCheckBox';
import wizardNavigation from './wizardNavigation';
import treeMenu from './treeMenu';
import mobileNavigation from './mobileNavigation';
import mobileMenu from './mobileMenu';
import actionsPopover from './actionsPopover';
import guide from './guide';
import { carouselImageSizes } from './carousel';
import { buttonCircledSizes } from './buttonCircled';
import emptyStateTopImageCardVariant from './emptyStateTopImageCardVariant';
var sizes = {
    actionsPopover: actionsPopover,
    actionsPopoverContainer: actionsPopoverContainer,
    button: button,
    buttonGroup: buttonGroup,
    fieldBox: fieldBox,
    textarea: textarea,
    chip: chip,
    exceptionList: exceptionList,
    emptyState: emptyState,
    emptyStateTopImageTableVariant: emptyStateTopImageTableVariant,
    emptyStateTopImageCardVariant: emptyStateTopImageCardVariant,
    checkBox: checkBox,
    optionList: optionList,
    optionListElement: optionListElement,
    avatar: avatar,
    timepicker: timepicker,
    radioButton: radioButton,
    breadCrumbs: breadCrumbs,
    badge: badge,
    tag: tag,
    accordion: accordion,
    tableBody: tableBody,
    tableRow: tableRow,
    toastTextContainer: toastTextContainer,
    toastTextWidth: toastTextWidth,
    toastContainer: toastContainer,
    navigation: navigation,
    menu: menu,
    menuMainLinks: menuMainLinks,
    menuSubLinks: menuSubLinks,
    modal: modal,
    modalContent: modalContent,
    dropzone: dropzone,
    multiAvatar: multiAvatar,
    drawer: drawer,
    drawerWide: drawerWide,
    drawerHeader: drawerHeader,
    toggle: toggle,
    toggleCircle: toggleCircle,
    tab: tab,
    tabActive: tabActive,
    tabSecondary: tabSecondary,
    tabCloseButton: tabCloseButton,
    tabBadge: tabBadge,
    dropdownMenu: dropdownMenu,
    dropdownOption: dropdownOption,
    banner: banner,
    bannerIconBackground: bannerIconBackground,
    wideCheckBox: wideCheckBox,
    wizardNavigation: wizardNavigation,
    treeMenu: treeMenu,
    mobileNavigation: mobileNavigation,
    mobileMenu: mobileMenu,
    headerHoverInput: headerHoverInput,
    headerHoverSearchButton: headerHoverSearchButton,
    carouselImageSizes: carouselImageSizes,
    buttonCircledSizes: buttonCircledSizes,
    guide: guide,
    horizontalWizardClosed: horizontalWizardClosed,
    horizontalWizardActive: horizontalWizardActive,
    horizontalWizardWarnings: horizontalWizardWarnings,
    horizontalWizardIcon: horizontalWizardIcon,
    buttonSegment: buttonSegment,
};
export default sizes;
